module.exports = __webpack_public_path__ + "media/PAG87-06.a6832296.mp3";